module.exports = __webpack_public_path__ + "img/shoppingcart.d325cec7.svg";